export default __webpack_public_path__ + "static/media/Hand-Mobile-Frame.8124281b.png";